module.exports = __webpack_public_path__ + "static/media/hubspot.82c1aa9b.svg";